<template>
  <div :class="bem()">
    <div class="int" :style="style">{{ priceInt }}</div>
    <div class="dot" v-if="isShoeDot" :style="style">{{ priceDot }}</div>
  </div>
</template>

<script>
import create from '../create'
import { formatNumber } from '@/utils/common'

export default create({
  name: 'price',
  props: {
    num: {
      type: [Number, String]
    },
    color: {
      type: String,
      default: 'transparent'
    }
  },
  computed: {
    style() {
      return {
        '-webkit-text-stroke': '0.5px ' + this.color
      }
    },
    formatNum() {
      return formatNumber(this.num)
    },
    isShoeDot() {
      return String(this.num).indexOf('.') > -1
    },
    priceInt() {
      return this.num ? parseInt(this.num) : this.num
    },
    priceDot() {
      return this.num && '.' + String(this.num).split('.')[1]
    }
  }
})
</script>
<style lang="scss" scoped src="./index.scss"></style>
